import React from "react";

const GridOne = () => {
    return(
        <div className="item-one">
            <img className="myimage" src="/images/mobile/image-transform.jpg" alt="Egg" />
        </div>
    )
}

export default GridOne;